import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mall-my-list" }
const _hoisted_2 = {
  key: 0,
  class: "mall-my-list__empty"
}
const _hoisted_3 = {
  key: 1,
  class: "mall-my-list__empty"
}
const _hoisted_4 = {
  key: 2,
  class: "mall-my-list__cards"
}
const _hoisted_5 = { class: "mall-my-list__meta" }
const _hoisted_6 = { class: "mall-my-list__title" }
const _hoisted_7 = {
  key: 0,
  class: "mall-my-list__sub"
}
const _hoisted_8 = { class: "mall-my-list__sub" }
const _hoisted_9 = { class: "mall-my-list__actions" }

import { onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import {
  MALL_ORDER_ITEM_STATUS_LABEL,
  fetchMyOrder,
  fetchMyOrders,
  type MallOrderItemStatus,
} from '@/api/mallOrder'
import { formatPrice } from '@/constants/mallProducts'
import { MALL_ORDERS_PATH } from '@/constants/mall'

interface ClaimRow {
  orderCode: string
  itemIdx: number
  productName: string
  option: string
  amount: number
  refundAmount: number
  returnCause: string
  orderedAt: string
  statusLabel: string
  claimReason: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MallMyClaimsPage',
  setup(__props) {

const CLAIM_STATUSES: MallOrderItemStatus[] = ['CANCEL_REQUEST', 'RETURN_REQUEST', 'CANCELED']

const loading = ref(true)
const rows = ref<ClaimRow[]>([])

onMounted(async () => {
  loading.value = true
  try {
    const orders = await fetchMyOrders()
    const claimOrders = orders.filter((order) =>
      (order.itemStatuses || []).some((status) => CLAIM_STATUSES.includes(status)),
    )
    const details = await Promise.all(
      claimOrders.map((order) => fetchMyOrder(order.code).catch(() => null)),
    )
    const next: ClaimRow[] = []
    for (const detail of details) {
      const order = detail?.order
      if (!order) continue
      for (const item of order.items || []) {
        if (!CLAIM_STATUSES.includes(item.status)) continue
        next.push({
          orderCode: order.code,
          itemIdx: item.idx,
          productName: item.name || '상품',
          option: item.option || '',
          amount: item.amount || 0,
          refundAmount: item.refundAmount || item.amount || 0,
          returnCause: item.returnCause || '',
          orderedAt: String(order.orderedAt || '').slice(0, 10),
          statusLabel: MALL_ORDER_ITEM_STATUS_LABEL[item.status] || item.status,
          claimReason: item.claimReason || '',
        })
      }
    }
    rows.value = next
  } catch {
    rows.value = []
  } finally {
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("header", { class: "mall-my-list__head" }, [
      _createElementVNode("h1", null, "취소 · 반품 · 환불 내역"),
      _createElementVNode("p", null, "요청 중이거나 처리된 취소·반품 주문을 모았습니다.")
    ], -1)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "불러오는 중입니다…"))
      : (!rows.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              icon: "mdi-clipboard-check-outline",
              size: 48
            }),
            _cache[1] || (_cache[1] = _createElementVNode("p", null, "취소·반품 내역이 없습니다", -1)),
            _createVNode(_component_router_link, { to: _unref(MALL_ORDERS_PATH) }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("주문목록 보기", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `${row.orderCode}-${row.itemIdx}`
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("strong", null, _toDisplayString(row.statusLabel), 1),
                  _createElementVNode("time", null, _toDisplayString(row.orderedAt), 1)
                ]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(row.productName), 1),
                (row.option)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(row.option), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(" 주문 " + _toDisplayString(row.orderCode) + " · 환불 " + _toDisplayString(_unref(formatPrice)(row.refundAmount)) + "원 ", 1),
                  (row.returnCause)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString(row.returnCause === 'CHANGE' ? '단순 변심' : '하자·오배송'), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (row.claimReason)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" · " + _toDisplayString(row.claimReason), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: `/mall/orders/${row.orderCode}`
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("주문 상세", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            }), 128))
          ]))
  ]))
}
}

})